import styled, { css } from 'styled-components';
import { calcOpacity } from 'utils/calcOpacity';
import { AVATAR_DESKTOP_INITIAL_SIZE, AVATAR_DESKTOP_INITIAL_TOP, AVATAR_MOBILE_INITIAL_SIZE } from '../constants';

const calcTop = (scrolledValue: number) => {
  if (scrolledValue > AVATAR_DESKTOP_INITIAL_SIZE) return `${40}px`;

  if (AVATAR_DESKTOP_INITIAL_SIZE - scrolledValue > AVATAR_DESKTOP_INITIAL_TOP)
    return `${AVATAR_DESKTOP_INITIAL_TOP}px`;

  const top =
    (scrolledValue - AVATAR_DESKTOP_INITIAL_SIZE + AVATAR_DESKTOP_INITIAL_TOP) * 0.7 + AVATAR_DESKTOP_INITIAL_TOP;

  return `${top}px`;
};

const calcSize = (isSmallProfile: boolean, scrolledValue: number) => {
  const initialValue = isSmallProfile ? AVATAR_MOBILE_INITIAL_SIZE : AVATAR_DESKTOP_INITIAL_SIZE;
  const size = initialValue - scrolledValue;

  return scrolledValue <= initialValue ? `width: ${size}px;  height: ${size}px;` : 'width: 0px;  height: 0px;';
};

const calcMarginRight = (scrolledValue: number) => {
  const margin = AVATAR_DESKTOP_INITIAL_SIZE - scrolledValue;

  if (margin >= 16) return '16px';

  if (margin > 0) return `${margin}px`;

  return '0px';
};

export const CustomAvatar = styled.div<{ isPaidFee?: boolean }>`
  ${({ theme, isPaidFee }) => css`
    border-radius: ${theme.border.radius.circle};
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: ${theme.color.text.neutral.strong};
    background-color: ${theme.color.background.neutral.weak};
    z-index: 22;
    display: flex;
    width: 100%;
    height: 100%;

    ${isPaidFee &&
    css`
      border: ${theme.border.width.thick} ${theme.border.style.solid} ${theme.color.support.blue.strong}80;
    `}

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `}
`;

export const AvatarWrapper = styled.div<{ scrolledValue: number; isSmallProfile?: boolean }>`
  ${({ isSmallProfile, scrolledValue }) => css`
    position: sticky;
    z-index: 20;

    ${calcSize(isSmallProfile, scrolledValue)}

    ${!isSmallProfile &&
    css`
      top: ${calcTop(scrolledValue)};
      margin-right: ${calcMarginRight(scrolledValue)};
      opacity: ${calcOpacity(AVATAR_DESKTOP_INITIAL_SIZE, scrolledValue)};
      display: ${scrolledValue <= AVATAR_DESKTOP_INITIAL_SIZE ? 'flex' : 'none'};
    `}

    ${isSmallProfile &&
    css`
      opacity: ${calcOpacity(AVATAR_MOBILE_INITIAL_SIZE, scrolledValue)};
    `}
  `}
`;

export const PaidFeeBadge = styled.div<{ scrolledValue: number }>`
  ${({ theme, scrolledValue }) => css`
    position: absolute;
    bottom: -8px;
    right: 3px;
    background-color: transparent;
    color: ${theme.color.support.blue.strong};
    z-index: 23;
    transform: scale(${calcOpacity(50, scrolledValue)});
  `}
`;
